module.exports = __webpack_public_path__ + "media/assets/images/curation/no_image-7ae81b318d2b299b1a4cd20a2fbfc853.svg";